import Layout from './Layout';
import SEOHead from './SEOHead';
import Welcome from './Home/Welcome';

export default function App() {
  return (
    <Layout>
      <SEOHead
        title="Prefab & Pre-Engineered Buildings | TR Structures"
        description="TR Structures offers prefab buildings, industrial sheds, fabrication services, steel fabrication, and pre-engineered buildings (PEB) with durable designs and fast project delivery across India."
        keywords="prefab buildings, pre-engineered buildings, PEB, industrial sheds, steel fabrication, fabrication services, prefab structures, industrial sheds India, Hyderabad, PEB manufacturer near me, industrial shed cost, PEB shed price per sq ft, industrial shed contractor Hyderabad, steel shed manufacturer Telangana"
      />
      <Welcome />
    </Layout>
  );
}